import React from "react";
import { FaApple } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { SiMicrosoft } from "react-icons/si";
import { EVENTS } from "../../constants/index";
import styles from "./CommonAuthFields.module.css";
import { storeLastUsedProvider } from "../../utils";
import { Auth } from "aws-amplify";
import { SocialButton } from "../SocialButton/SocialButton";

const GOOGLE = "Google";
const APPLE = "SignInWithApple";
const MICROSOFT = "Microsoft";
const CUSTOM_PROVIDERS = [MICROSOFT];
const SOCIAL_SIGNUP_SOURCE = "skillradar";

export const CommonAuthFields = ({ handleSocialClick, isSignup = false }) => {
  const callFederatedSignIn = (provider, event) => {
    const customState = isSignup
      ? JSON.stringify({
          source: SOCIAL_SIGNUP_SOURCE,
          accountType: "employer",
        })
      : undefined;

    handleSocialClick(event);
    storeLastUsedProvider(provider);
    if (isSignup) {
      localStorage.setItem("cognitoSource", SOCIAL_SIGNUP_SOURCE);
      localStorage.setItem("asEmployer", true);
      localStorage.removeItem("asTalent");
    }

    Auth.federatedSignIn({
      ...(CUSTOM_PROVIDERS.includes(provider)
        ? { customProvider: provider }
        : { provider }),
      ...(customState ? { customState } : {}),
    });
  };

  const lastUsedProvider = localStorage.getItem("lastUsedProvider");
  const signUpLabel = (providerLabel) =>
    isSignup ? `Sign Up with ${providerLabel}` : `Continue with ${providerLabel}`;

  return (
    <div className={styles.wrap}>
      <div className={styles.socialGrid}>
        <SocialButton
          icon={<FcGoogle />}
          title={signUpLabel("Google")}
          onClick={callFederatedSignIn}
          provider={GOOGLE}
          isLastUsed={!isSignup && lastUsedProvider === GOOGLE}
          eventName={
            isSignup ? EVENTS.GOOGLE_SIGNUP_CLICK : EVENTS.GOOGLE_SIGNIN_CLICK
          }
        />

        <SocialButton
          icon={<SiMicrosoft color="#00a4ef" />}
          title={signUpLabel("Microsoft")}
          onClick={callFederatedSignIn}
          provider={MICROSOFT}
          isLastUsed={!isSignup && lastUsedProvider === MICROSOFT}
          eventName={
            isSignup
              ? EVENTS.MICROSOFT_SIGNUP_CLICK
              : EVENTS.MICROSOFT_SIGNIN_CLICK
          }
        />

        <SocialButton
          icon={<FaApple color="#111827" />}
          title={signUpLabel("Apple")}
          onClick={callFederatedSignIn}
          isLastUsed={!isSignup && lastUsedProvider === APPLE}
          provider={APPLE}
          eventName={
            isSignup ? EVENTS.APPLE_SIGNUP_CLICK : EVENTS.APPLE_SIGNIN_CLICK
          }
        />
      </div>

      <div className={styles.orRow}>
        <span className={styles.line} />
        <span className={styles.orText}>OR</span>
        <span className={styles.line} />
      </div>
    </div>
  );
};
